import React from 'react';
import { Heading, Flex, Text, Box } from '@chakra-ui/react';
import { MdLocalOffer } from 'react-icons/md';

const TeamActivityTitleSection = ({ tag, title, blogPost }) => {
  // Safely handle tag field - ensure it's always a string
  let safeTag = "TeamActivity"; // default

if (typeof tag === "object") {
  const value = tag?.fullName || tag?.name || tag?.text || "News";
  safeTag = value.toLowerCase() === "news" ? "News" : "TeamActivity";
} else {
  safeTag = (tag?.toString().toLowerCase() === "news") ? "News" : "TeamActivity";
}

  // Format the date to a readable format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return '';
      }
      const options = { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      console.error('Error formatting date:', error);
      return ''; // Return empty string if formatting fails
    }
  };

  // Try multiple possible date fields
  const dateToUse = blogPost?.published_date;
  const formattedDate = formatDate(dateToUse);
  const venue = blogPost?.venue;

  return (
    <Box mb={4}>
      <Heading as="h1" fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }} color="#234236" fontWeight="bold" mb={2}>
        {title}
      </Heading>
      <Flex align="center" gap={2} color="gray.600" fontSize="md" flexWrap="wrap">
        <Box as={MdLocalOffer} fontSize="lg" color="gray.600" />
        <Text as="span" fontWeight="medium">{safeTag}</Text>
        {formattedDate && (
          <>
            <Text as="span" mx={2}>•</Text>
            <Text as="span">Date: {formattedDate}</Text>
          </>
        )}
        {!formattedDate && dateToUse && (
          <>
            <Text as="span" mx={2}>•</Text>
            <Text as="span" color="orange.500">Date: {dateToUse}</Text>
          </>
        )}
        {venue && (
          <>
            <Text as="span" mx={2}>•</Text>
            <Text as="span">Venue: {venue}</Text>
          </>
        )}
      </Flex>
    </Box>
  );
};

export default TeamActivityTitleSection; 